module.exports = __webpack_public_path__ + "img/VIPbg.ab99b159.svg";